import React, { useEffect } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { ON_ROUTE_CHANGE } from 'actions/header';
import UserDocuments from 'components/List/UserDocuments';
import Logout from 'components/Logout/Logout';
import App from 'containers/App';
import MyAssessments from 'containers/AssessmentsTab/MyAssessments';
import AttendanceTabSections from 'containers/AttendanceTab/AttendanceTabSections';
import SingleLesson from 'containers/Lesson/Single';
import NotFound from 'containers/NotFound';
import Plans from 'containers/Plans/Plans';
import SectionProgress from 'containers/Progress/Section';
import PrintApp from 'containers/PrintApp';
import SubmissionsView from 'containers/SinglePages/Assignment/SubmissionsView';
import PlanningWrapper from 'containers/SinglePages/Plan/PlanningWrapper';
import SingleAssignmentV1 from 'containers/SinglePages/SingleAssignmentV1';
import SingleCourse from 'containers/SinglePages/SingleCourse';
import Tasks from 'containers/Tasks/Tasks';
import TeamsApp from 'teams/App';
import CreateCourses from 'teams/containers/Courses/Create';
import HaldorTab from 'teams/containers/HaldorTab';
import TabConfigure from 'teams/containers/TabConfigure';
import PrintPlan from 'containers/PrintPages/PrintPlanning';
import AuthenticationCallback from 'components/Login/AuthenticationCallback';
import Authenticate from 'components/Login/Authenticate';
import TeamsOnboardingIndex from 'containers/TeamsOnboarding/IndexWrapper';
import { appInsights } from 'lib/appInsights';

var Routes = function Routes(props) {
  var currentPath = window.location.pathname;
  useEffect(function () {
    props.history.listen(function (location) {
      var forbiddenRoutes = ["language", "switch", "conversations/new", "Auth"];

      if (window.location.pathname == currentPath) {
        return false;
      }

      if (window.location.hostname != 'localhost') {
        appInsights.trackPageView({
          name: location.pathname,
          isLoggedIn: appInsights.context.user.authenticatedId != null
        });
      }

      var route = forbiddenRoutes.find(function (t) {
        return location.pathname.indexOf(t) > -1;
      });

      if (route != null) {
        return false;
      }

      var body = document.body;

      if (body != null) {
        if (body.style.overflow == 'hidden') {
          body.style.overflow = 'initial';
        }

        var menu = body.querySelector('.c--sider');

        if (menu != null && menu.style.display == 'none') {
          menu.style.display = 'block';
        }

        var header = body.querySelector('.desktop-header');

        if (header != null && header.style.display == 'none') {
          header.style.display = 'flex';
        }
      }

      currentPath = window.location.pathname;
      props.store.dispatch({
        type: ON_ROUTE_CHANGE
      });
      window.scrollTo(0, 0);
      var event = new Event('route_change');
      document.dispatchEvent(event);
    });
  }, []);
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/logout",
    component: Logout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/authenticate/callback",
    exact: true,
    component: AuthenticationCallback
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/authenticate",
    exact: true,
    component: Authenticate
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/onboarding",
    exact: true,
    component: TeamsOnboardingIndex
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/configure",
    component: TabConfigure
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/haldor-tab",
    render: function render() {
      return /*#__PURE__*/React.createElement(TeamsApp, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab",
        exact: true,
        component: HaldorTab
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/onboarding",
        exact: true,
        component: TeamsOnboardingIndex
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/assignment/:assignmentId/submission/:submissionId/documents",
        component: SubmissionsView
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/assignment/:assignmentId/task/:taskId/documents",
        component: UserDocuments
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/assignment/:assignmentId",
        component: SingleAssignmentV1,
        exact: true
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/assignments",
        component: Tasks
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/plan/:planId",
        component: PlanningWrapper
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/print/plan/:planId",
        component: PrintPlan
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/courses/create/:courseId",
        component: CreateCourses
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/courses/create",
        component: CreateCourses
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/course/:courseId",
        component: SingleCourse
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/haldor-tab/groups/:groupId/progress/:userId",
        component: SectionProgress
      })));
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/print",
    component: PrintApp
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: App
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: NotFound
  }));
};

export default withRouter(Routes);